import React from "react";

import { FetchBlurb } from "views/common/misc/FetchBlurb";

export interface MarketingBlurbsProps {
  text: string;
}
interface IBlurb {
  title: string;
  message: string;
}

export const MarketingBlurbs: React.FC<MarketingBlurbsProps> = () => {
  const blurbs: IBlurb[] = [
    {
      message:
        "Fetch provides a safe, reliable and convenient way to get your online orders.",
      title: "Deliveries on your time",
    },
    {
      message:
        "Simply ship your packages using your new Fetch address. Be sure to include your unique user code.",
      title: "Address Change",
    },
    {
      message: "Delivery options seven days a week that suit your schedule.",
      title: "Choose a convenient delivery window",
    },
    {
      message: "Your packages are delivered safely to your door on your time.",
      title: "Worry-free Delivery",
    },
  ];
  return (
    <div className="marketing-blurbs">
      {blurbs.map((blurb: IBlurb, index: number) => (
        <FetchBlurb key={`blurb-${index}`} {...blurb} />
      ))}
    </div>
  );
};

MarketingBlurbs.defaultProps = {};
